// src/components/EmailListContainer.jsx
import React, { useState } from 'react';
import {
  Box,
  TextField,
  MenuItem,
  Divider,
  Tooltip,
  Typography,
  Badge,
  Chip
} from '@mui/material';
import { acme } from '../../theme/acmeTheme';
import { Menu } from '../ui';
import EmptyState from '../ui/EmptyState';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton } from '../ui';
import EmailList from './EmailList';

// ??????? ??? ?????????????? ???? ? ??????? dd.mm.yyyy HH:mm
function formatDate(date) {
  if (!date) return '';
  const d = new Date(date);
  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const year = d.getFullYear();
  const hours = d.getHours().toString().padStart(2, '0');
  const minutes = d.getMinutes().toString().padStart(2, '0');
  return `${day}.${month}.${year} ${hours}:${minutes}`;
}

const EmailListContainer = ({ emails, onSelectEmail, selectedEmail }) => {
  // ????????? ??? ??????
  const [searchQuery, setSearchQuery] = useState('');

  // ?????? ? ?????????? ?? ?????????
  const [filterOption, setFilterOption] = useState('all'); // "all" ??? "unread"
  const [sortField, setSortField] = useState('date'); // date, from, subject
  const [sortOrder, setSortOrder] = useState('desc'); // desc ??? asc

  // ????????? ??? ??????????? ??????????? ???? ???????
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);

  const handleFilterIconClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  // ??????????
  const filteredEmails = emails.filter((email) => {
    const combinedText = (
      (email.subject || '') +
      ' ' +
      (email.from || '') +
      ' ' +
      (email.to || '') +
      ' ' +
      (email.text || '')
    ).toLowerCase();
    if (searchQuery && !combinedText.includes(searchQuery.toLowerCase())) {
      return false;
    }
    if (filterOption === 'unread' && !email.unread) {
      return false;
    }
    return true;
  });

  // ??????????
  const sortedEmails = [...filteredEmails].sort((a, b) => {
    if (sortField === 'date') {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return sortOrder === 'desc' ? dateB - dateA : dateA - dateB;
    }
    if (sortField === 'from') {
      const nameA = (a.from || '').toLowerCase();
      const nameB = (b.from || '').toLowerCase();
      if (nameA < nameB) return sortOrder === 'asc' ? -1 : 1;
      if (nameA > nameB) return sortOrder === 'asc' ? 1 : -1;
      return 0;
    }
    if (sortField === 'subject') {
      const subjA = (a.subject || '').toLowerCase();
      const subjB = (b.subject || '').toLowerCase();
      if (subjA < subjB) return sortOrder === 'asc' ? -1 : 1;
      if (subjA > subjB) return sortOrder === 'asc' ? 1 : -1;
      return 0;
    }
    return 0;
  });

  const unreadCount = emails.filter(email => email.unread).length;

  return (
    <Box sx={{ pt: 2, width: '100%', minWidth: 400 }}>
      {/* Заголовок с информацией */}
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Typography 
            variant="h6" 
            sx={{ 
              fontWeight: 600, 
              color: acme.colors.foreground,
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            📧 Email List
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Chip 
              label={`${emails.length} total`}
              size="small" 
              variant="outlined"
              sx={{ 
                borderColor: acme.colors.border,
                color: acme.colors.brand,
                fontWeight: 500
              }}
            />
            {unreadCount > 0 && (
              <Chip 
                label={`${unreadCount} unread`}
                size="small" 
                sx={{ 
                  backgroundColor: acme.colors.brand,
                  color: acme.colors.brandForeground,
                  fontWeight: 500
                }}
              />
            )}
          </Box>
        </Box>
        
        {/* ??????? ??????: ?????? ?????? ? ?????? ??????? */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <TextField
            label="Search emails..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            size="small"
            InputProps={{
              startAdornment: <SearchIcon sx={{ color: acme.colors.iconDefault, mr: 1 }} />,
            }}
            sx={{ 
              flex: 1,
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                '& fieldset': {
                  borderColor: acme.colors.border,
                },
                '&:hover fieldset': {
                  borderColor: acme.colors.brand,
                },
                '&.Mui-focused fieldset': {
                  borderColor: acme.colors.brand,
                },
              },
              '& .MuiInputLabel-root': {
                color: acme.colors.mutedForegroundSolid,
                '&.Mui-focused': {
                  color: acme.colors.brand,
                },
              },
            }}
          />
          <Tooltip title="Filter & Sort">
            <IconButton 
              onClick={handleFilterIconClick} 
              size="small"
              sx={{
                backgroundColor: acme.colors.brandMuted,
                color: acme.colors.brand,
                borderRadius: 2,
                '&:hover': {
                  backgroundColor: acme.colors.brand,
                  color: acme.colors.brandForeground,
                },
                transition: 'all 0.2s ease',
              }}
            >
              <Badge 
                badgeContent={filterOption === 'unread' || sortField !== 'date' || sortOrder !== 'desc' ? '•' : null}
                sx={{
                  '& .MuiBadge-badge': {
                    backgroundColor: acme.colors.brand,
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    minWidth: 8,
                  },
                }}
              >
                <FilterListIcon />
              </Badge>
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <Menu
        anchorEl={filterAnchorEl}
        open={Boolean(filterAnchorEl)}
        onClose={handleFilterClose}
        PaperProps={{ 
          elevation: 3,
          sx: { 
            width: 280,
            borderRadius: 2,
            border: `1px solid ${acme.colors.border}`,
            '& .MuiMenuItem-root': {
              borderRadius: 1,
              margin: '2px 8px',
              '&:hover': {
                backgroundColor: acme.colors.brandMuted,
                color: acme.colors.brand,
              },
              '&.Mui-selected': {
                backgroundColor: acme.colors.brandMuted,
                color: acme.colors.brand,
              },
            },
          }
        }}
      >
        <MenuItem disabled>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, color: acme.colors.brand }}>
            📋 Filter Options
          </Typography>
        </MenuItem>
        <MenuItem
          selected={filterOption === 'all'}
          onClick={() => { setFilterOption('all'); handleFilterClose(); }}
        >
          All messages ({emails.length})
        </MenuItem>
        <MenuItem
          selected={filterOption === 'unread'}
          onClick={() => { setFilterOption('unread'); handleFilterClose(); }}
        >
          Unread messages ({unreadCount})
        </MenuItem>
        <Divider sx={{ my: 1, borderColor: acme.colors.border }} />
        <MenuItem disabled>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, color: acme.colors.brand }}>
            📊 Sort Options
          </Typography>
        </MenuItem>
        <MenuItem
          selected={sortField === 'date'}
          onClick={() => { setSortField('date'); handleFilterClose(); }}
        >
          📅 Sort by Date
        </MenuItem>
        <MenuItem
          selected={sortField === 'from'}
          onClick={() => { setSortField('from'); handleFilterClose(); }}
        >
          👤 Sort by Sender
        </MenuItem>
        <MenuItem
          selected={sortField === 'subject'}
          onClick={() => { setSortField('subject'); handleFilterClose(); }}
        >
          📝 Sort by Subject
        </MenuItem>
        <Divider sx={{ my: 1, borderColor: acme.colors.border }} />
        <MenuItem disabled>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, color: acme.colors.brand }}>
            🔄 Order
          </Typography>
        </MenuItem>
        <MenuItem
          selected={sortOrder === 'desc'}
          onClick={() => { setSortOrder('desc'); handleFilterClose(); }}
        >
          ⬇️ Newest first
        </MenuItem>
        <MenuItem
          selected={sortOrder === 'asc'}
          onClick={() => { setSortOrder('asc'); handleFilterClose(); }}
        >
          ⬆️ Oldest first
        </MenuItem>
      </Menu>
      
      <Divider sx={{ mb: 2, borderColor: acme.colors.border }} />

      {/* ??? ?????? ????? */}
      <Box sx={{ width: '100%' }}>
        {sortedEmails.length === 0 ? (
          <EmptyState
            title="No emails found"
            description={
              searchQuery
                ? `No emails match your search "${searchQuery}"`
                : filterOption === 'unread'
                  ? 'No unread emails in this folder'
                  : 'No emails in this folder'
            }
            sx={{ py: 6 }}
          />
        ) : (
          <EmailList
            emails={sortedEmails}
            onSelectEmail={onSelectEmail}
            selectedEmail={selectedEmail}
            formatDate={formatDate}
          />
        )}
      </Box>
    </Box>
  );
};

export default EmailListContainer;
